import * as v from 'valibot'
import {
  ExtraPackageBoostType,
  ExtraPackageCampaignCategory,
} from 'src/services/apollo/generated/graphql'

// Partially copied from packages/pixai-server/zodSchema/userQuotaLogExtra.ts
const UserQuotaLogExtraKeys = {
  loraId: 'loraId',
  boosts: 'boosts',
  reason: 'reason',
} as const

const boostSchema = v.object({
  name: v.string(),
  percentage: v.number(),
  type: v.enum(ExtraPackageBoostType),
  category: v.optional(v.enum(ExtraPackageCampaignCategory)),
  couponCode: v.optional(v.string()),
})

export const userQuotaLogExtraSchema = v.object({
  [UserQuotaLogExtraKeys.loraId]: v.optional(v.string()),
  [UserQuotaLogExtraKeys.boosts]: v.optional(v.array(boostSchema)),
  [UserQuotaLogExtraKeys.reason]: v.optional(v.string()),
})
